import { Outlet } from "react-router-dom";
import GeneralLayout from "./GeneralLayout";
import { IoIosLogOut } from "react-icons/io";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { logout as appLogout, selectAuthSlice } from "../store/authSlice";
import { IconWrapper } from "../customHooks/useIcon";
import PoweredBy from "./PoweredBy";
import LanguageSwitcher from "./switchLanguage";

const AdminLayout = () => {
  const { logout } = useAuth0();
  const dispatch = useAppDispatch();
  const handleLogout = () => {
    logout({
      logoutParams: { returnTo: `${window.location.origin}/auth/login` },
    });
    dispatch(appLogout());
  };
  const user_info = useAppSelector(selectAuthSlice).user;
  return (
    <GeneralLayout>
      <div className="bg-white bg-opacity-80 min-h-[100vh] p-6 flex flex-col">
        <div className="flex justify-between items-center text h-[5rem]">
          {/* logo section */}
          <div className="max-w-[200px]">
            <img
              src={user_info?.company.logo}
              alt={user_info?.company.name}
              className="max-h-[60px]"
            />
          </div>
          {/* choose language  */}
          {/* <div className="rounded-md border w-[3rem] h-[20px]">
          <BsGlobe2 />
          <span className="text-xs">Choose language</span>
          <IoIosArrowDown />
        </div> */}
        </div>
        <div className="relative flex-1 flex flex-col items-center justify-center">
          <div className="absolute flex gap-2 right-5 top-5">
            <LanguageSwitcher />
            <span className="cursor-pointer mt-[20px]">
              <IconWrapper
                icon={IoIosLogOut}
                size={22}
                className=""
                onClick={handleLogout}
              />
            </span>
          </div>
          <Outlet />
        </div>
        {user_info && !user_info?.company.name.includes("Smarterise") && (
          <PoweredBy className="w-[10rem] !bg-inherit" />
        )}
      </div>
    </GeneralLayout>
  );
};

export default AdminLayout;
